import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import SiteNav from "@/components/site/SiteNav";
import SiteFooter from "@/components/site/SiteFooter";
import PageHero from "@/components/site/PageHero";
import BottomCTA from "@/components/site/BottomCTA";
import useReveal from "@/hooks/useReveal";
import { LEADERSHIP } from "@/data/content";
import { pickLocale } from "@/i18n";

export default function Leadership() {
  useReveal();
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-white text-unik-ink">
      <SiteNav />
      <PageHero
        eyebrow={t("leadership.heroEyebrow")}
        title={t("leadership.heroTitle")}
        accent={<><br/>{t("leadership.heroAccent")}</>}
        sub={t("leadership.heroSub")}
        bgImage="/assets/unsplash-1583417319070.jpg"
      />

      <section className="relative bg-[#f3f4f6] py-28 lg:py-40">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {LEADERSHIP.map((m, i) => (
              <Link
                key={m.name}
                to={`/leadership/${m.slug}`}
                data-reveal
                style={{ "--reveal-delay": `${i * 120}ms` }}
                className="group block"
                data-testid={`leader-card-${m.slug}`}
              >
                <div className="aspect-[3/4] overflow-hidden bg-[#14355a]/5">
                  <img
                    src={m.img}
                    alt={m.name}
                    className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-105"
                  />
                </div>
                <div className="mt-6">
                  <h3
                    style={{ fontSize: "clamp(1.25rem, 1.6vw, 1.5rem)", fontWeight: 500 }}
                    className="font-display text-[#14355a] tracking-tight"
                  >
                    {pickLocale(m, "name")}
                  </h3>
                  <p className="mt-3 text-[14px] lg:text-[15px] text-black leading-[1.5]" style={{ fontWeight: 500 }}>
                    {pickLocale(m, "role")}
                  </p>
                  <p className="mt-4 text-[15px] leading-[1.85] text-black">
                    {pickLocale(m, "short")}
                  </p>
                  <span className="inline-flex items-center gap-2 mt-5 text-[#14355a] text-xs uppercase tracking-[0.2em] font-display font-medium group-hover:text-unik-gold transition-colors">
                    {t("common.readMore")} <ArrowUpRight size={14} />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <BottomCTA
        eyebrow={t("leadership.bottomCta.eyebrow")}
        title={t("leadership.bottomCta.title")}
        accent={t("leadership.bottomCta.accent")}
        body={t("leadership.bottomCta.body")}
        primary={{ label: t("leadership.bottomCta.primary"), to: "/about/careers" }}
        secondary={{ label: t("leadership.bottomCta.secondary"), to: "/contact" }}
      />
      <SiteFooter />
    </div>
  );
}
